<template>
  <!-- 通知栏 -->
  <div
    class="notice-container"
    v-if="!appReminder || !data"
    :style="{ top: tabBarHeight + statusBarHeight + 'px' }"
    @click="bindToSet"
  >
    注意哦！betterWE 检测到系统提醒已关闭，请点击此处设置～
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Boolean,
      default: true
    },
    cupType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      appReminder: true, //app是否开启通知
      tabBarHeight: 0,
      statusBarHeight: 0
    }
  },
  created() {
    this.getAppReminder()
    this.getTabBar()
  },
  methods: {
    async getTabBar() {
      let res = await this.$betterwe.getAppBarHeight().catch(() => {})
      if (res !== undefined) {
        this.tabBarHeight = res.toolsBarHeight
        this.statusBarHeight = res.statusBarHeight
      }
    },
    //获取app通知
    async getAppReminder() {
      if (this.$betterwe.isApp()) {
        let res = await this.$betterwe
          .getNotificationPermissionStatus()
          .catch(() => {})
        console.log(res)
        if (res !== undefined) {
          this.appReminder = !!parseInt(res)
        }
      }
    },
    async setAppReminder() {
      if (this.$betterwe.isApp()) {
        let res = await this.$betterwe
          .requestNotificationPermission()
          .catch(() => {})
        if (res !== undefined) {
          this.appReminder = !!parseInt(res)
        }
      }
    },
    //去设置界面或者打开app消息通知
    bindToSet() {
      if (!this.appReminder) {
        //app通知未开启
        this.setAppReminder()
      } else if (!this.serviceReminder) {
        let urls = {
          1: '/drink-water-reminder/set',
          2: '/drink-water-reminder/normal/set'
        }
        this.$router.push(urls[this.cupType])
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.notice-container {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
  position: sticky;
  top: 0px;
  left: 0;
  width: 100%;
  z-index: 1;
  height: 30px;
  background: #9191ff;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #ffffff;
  line-height: 30px;
}
</style>
